<div class="wrapper">
    <div class="icon">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2" class="status">
            <circle
                class="path circle"
                fill="none"
                stroke="#73AF55"
                stroke-width="6"
                stroke-miterlimit="10"
                cx="65.1"
                cy="65.1"
                r="62.1"
            />
            <polyline
                class="path check"
                fill="none"
                stroke="#73AF55"
                stroke-width="6"
                stroke-linecap="round"
                stroke-miterlimit="10"
                points="100.2,40.2 51.5,88.8 29.8,67.5 "
            />
        </svg>
    </div>

    <div class="content">
        <h2>Your order was placed successfully</h2>
    </div>
</div>

<div class="info">
    <div class="left">
        <h3>What's Next?</h3>
        <p>
            You'll get a confirmation email within the next few minutes. This email includes your transaction ID and a
            receipt, so please keep it for your records.
        </p>

        <p>
            If there are site benefits included in the tier you ordered, they will automatically activate once your
            payment is processed. Most payments are processed instantly, but in some situations a manual review from our
            security team is required. If you have not received your perks, feel free to
            <a href="javascript:;" (click)="openSupportModal()">contact us</a> at any time for more information on your
            order's status.
        </p>

        <p>
            <a [href]="successUrl">Return to the site <i class="fas fa-external-link-alt" aria-hidden="true"></i></a>
        </p>
    </div>
</div>
